import { useHttpClient } from "@xemplo/http";
import { getHook, setHook } from "react-hooks-outside";

setHook("httpClient", useHttpClient);
export const httpClient = () => getHook("httpClient");
